import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction, toJS} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../contexts";
import FormField from "../Helpers/FormField";
import {input} from "../../utils/linker";

function CategoryAccess(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compContext = useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  // console.log('compContext.groups', toJS(compContext.groups));

  const curView=compContext.curView();

  if(!compContext.permissions.inited || !compContext.groups.inited) {
    return null;
  }


  return (
    <div>
      <div className="up12 margin s-size-1">
        {compContext.groups.data.items.map((group)=>{
          return (
            <div className="cell">
              <FormField key={group.id} title={group.name}>
                <span className="select w100"><select {...input(curView.access, group.id)}>
                  {compContext.permissions.data.map((perm)=>{
                    return <option value={perm.id}>{perm.name}</option>
                  })}
                </select></span>
              </FormField>
            </div>
          )
        })}
      </div>
    </div>
  )
};

CategoryAccess.defaultProps = {};

CategoryAccess.propTypes = {}

export default observer(CategoryAccess);
